import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter} from '@angular/core';
import {cardToggle, cardClose, cardIconToggle} from './card-animation';
import {Router} from '@angular/router';

export interface IButton {
  btnName?: string;
  btnIcon?: string;
  btnIconAfter?: string;
  btnUrl?: string;
  method?: Function|string;
  btnCustomClass?: string;
  key?: string;
}

export interface DButton {
  name?: string;
  dropdownItems?: IButton[];
  btnCustomClass?: string;
  key?: string;
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  animations: [cardToggle, cardClose, cardIconToggle],
  encapsulation: ViewEncapsulation.None
})

export class CardComponent implements OnInit {
  @Input() headerContent: string;
  @Input() innerHtmlHeader: string;
  @Input() showActionButtons: boolean= true;;
  @Input() title: string;
  @Input() blockClass: string;
  @Input() headerClass: string;
  @Input() headerTitleClass: string;
  @Input() cardClass: string;
  @Input() hideHeader = false;
  @Input() classHeader = false;
  @Input() cardOptionBlock = true;
  @Input() fullScreenButton = false;
  @Input() minimizeButton = false;
  @Input() refreshButton = false;
  @Input() closeButton = false;
  @Input() cardOptionBtn = false;
  @Input() titleHasIcon = false;
  @Input() titleIconActive = false;
  @Input() customTitle = null;
  @Input() cardOptionBtnValue: string;
  @Input() cardOptionBtnIcon: string;
  @Input() simpleBtnCustomClass: string = 'btn btn-primary cardAddBtn';
  @Input() cardRouterLink: string;

  @Input() advanceButton = false;
  @Input() advancedButtons: IButton[];
  @Input() dropdownButton: DButton;

  cardToggle = 'expanded';
  cardClose = 'open';
  fullCard: string;
  fullCardIcon: string;
  loadCard = false;
  isCardToggled = false;
  cardLoad: string;
  cardIconToggle: string;
  @Output() outputButton = new EventEmitter<boolean>();
  @Output() outputButtonAdvance = new EventEmitter<string>();
  @Output() outputDropdownButton = new EventEmitter<string>();

  constructor(private router: Router) {
    this.fullCardIcon = 'icon-maximize';
    this.cardIconToggle = 'an-off';
  }

  ngOnInit() {
    if (this.cardOptionBlock) {
      this.cardToggle = 'false';
    }


  }

  redirectToUrl() {
    if (!this.cardRouterLink) {
      this.outputButton.emit(true);
    } else {
      this.router.navigateByUrl(this.cardRouterLink);
    }
  }

  toggleCard(event) {
    this.cardToggle = this.cardToggle === 'collapsed' ? 'expanded' : 'collapsed';
  }

  toggleCardOption() {
    this.isCardToggled = !this.isCardToggled;
    this.cardIconToggle = this.cardIconToggle === 'an-off' ? 'an-animate' : 'an-off';
  }

  closeCard(event) {
    this.cardClose = this.cardClose === 'closed' ? 'open' : 'closed';
  }

  fullScreen(event) {
    this.fullCard = this.fullCard === 'full-card' ? '' : 'full-card';
    this.fullCardIcon = this.fullCardIcon === 'icon-maximize' ? 'icon-minimize' : 'icon-maximize';
  }

  cardRefresh() {
    this.loadCard = true;
    this.cardLoad = 'card-load';
    setTimeout(() => {
      this.cardLoad = '';
      this.loadCard = false;
    }, 3000);
  }

  redirectToUrlAdvanced(btn) {
    if (btn.btnUrl) {
      this.router.navigateByUrl(btn.btnUrl);
    } else {
      this.outputButtonAdvance.emit(btn.method);
    }
  }

  redirectToUrlDropDownItem(btn) {
    this.outputDropdownButton.emit(btn);
  }
}



